import { addStyles } from 'ethcss'
import { grid, item, IStyles, color } from '../../theme'
import { defaultThemeStyles } from './collapse.theme'
import { textSizes } from 'theme/media'

const collapseStyles: IStyles = {
    wrapper: {
        ...item.panel,
        ...grid.p_none,
    },
    titleWrapper: {
        color: color.fontDarkUltraHigh,
        fontWeight: 500,
        width: 'calc(100% - 20px)',
    },
    title: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        fontSize: textSizes.normal,
        ...item.pointer,
        padding: '12px 16px',
        color: `var(--var-module-ui-component-collapse-style-textMain, ${defaultThemeStyles.textMain})`,
    },
    contentWrapper: {
        ...item.transitionErase,
        ...item.overNone,
    },
    content: {
        padding: 16,
    },
    withoutOverflow: {
        overflow: 'visible!important',
    },
    noWrap: {
        flexWrap: 'nowrap !important',
    },
}

addStyles(collapseStyles)
export default collapseStyles
